import FormControl from '@mui/material/FormControl/FormControl';
import TextField from '@mui/material/TextField';
import React from 'react';
import SegmentSelectBox from '../SegmentSelectBox';
import OperandSelectBox from '../OperandSelectBox';

export default function HTMLAttributeCondition({ condition, onChange }) {
    const operands = [
        { value: 'includes', label: 'contains' },
        { value: 'does_not_include', label: 'does not contain' },
        { value: 'is', label: 'is' },
        { value: 'is_not', label: 'is not' },
    ];

    if (!condition.operand) {
        onChange({ target: { name: 'operand', value: 'includes' } });
    }

    const [selector, attributeName] = (condition.key_name || '').split('|');

    return (
        <div className="condition-ruleset">
            <SegmentSelectBox value={condition.segment} onChange={onChange} />
            <FormControl variant="outlined">
                <TextField
                    size="small"
                    name="key_name"
                    onChange={(e) =>
                        onChange({
                            target: {
                                name: 'key_name',
                                value: `${e.currentTarget.value}|${attributeName || ''}`,
                            },
                        })
                    }
                    value={selector || ''}
                    placeholder="selector (e.g. html)"
                    variant="outlined"
                />
            </FormControl>
            <FormControl variant="outlined">
                <TextField
                    size="small"
                    name="attribute_name"
                    onChange={(e) =>
                        onChange({
                            target: {
                                name: 'key_name',
                                value: `${selector || ''}|${e.currentTarget.value}`,
                            },
                        })
                    }
                    value={attributeName || ''}
                    placeholder="attribute (e.g. lang)"
                    variant="outlined"
                />
            </FormControl>
            <OperandSelectBox
                operands={operands}
                value={condition.operand}
                onChange={onChange}
            />
            <FormControl variant="outlined">
                <TextField
                    size="small"
                    name="value"
                    onChange={(e) =>
                        onChange({
                            target: { name: 'value', value: e.currentTarget.value },
                        })
                    }
                    value={condition.value}
                    placeholder="value"
                    variant="outlined"
                />
            </FormControl>
        </div>
    );
}
